import * as React from 'react';
import { useState } from 'react';
import Submenu from '../../components/Submenu/Submenu';
import VariantForm from "../../components/Variants/VariantForm/VariantForm";
import AppMenus from '../../config/appMenus';
import AppRoutes from '../../config/appRoutes';
var Variant = function () {
    var appMenus = new AppMenus();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var submenu = null;
    if (isEdit) {
        submenu = React.createElement(Submenu, { menuItems: appMenus.subMenuItems[AppRoutes.editVariant.key] });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u0432\u0430\u0440\u0438\u0430\u043D\u0442"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                isEdit ? submenu : null,
                React.createElement("div", { className: "col-md-5 " + (isEdit ? '' : 'offset-md-4') },
                    React.createElement(VariantForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default Variant;



//////////////////
// WEBPACK FOOTER
// ./src/views/Variants/Variant.tsx
// module id = 503
// module chunks = 0